import React from 'react';
import PropTypes from 'prop-types';
import { BuildingIcon } from '../icons';
import {
  formatVenueSpaceCardSubtitle,
  normalizeVenueSpacesForDisplay
} from '../../utils/venueSpacesDisplay';

const VenueSpacesSection = ({ spaces = [] }) => {
  const displaySpaces = normalizeVenueSpacesForDisplay(spaces);

  return (
    <section className="venue-booking-options venue-spaces-section" aria-labelledby="venue-spaces-heading">
      <h3 id="venue-spaces-heading" className="venue-section-title">
        Spaces
      </h3>
      <div className="booking-options-grid booking-options-grid--spaces">
        {displaySpaces.length === 0 ? (
          <div className="booking-options-empty">No spaces available yet.</div>
        ) : (
          displaySpaces.map((space, index) => {
            const subtitle = formatVenueSpaceCardSubtitle(space);
            return (
              <div
                className="booking-option-card venue-space-card"
                key={space.id || space.name || index}
              >
                <div className="booking-option-icon" aria-hidden="true">
                  <BuildingIcon />
                </div>
                <div className="booking-option-text">
                  <span className="booking-option-title">{space.name}</span>
                  {subtitle ? <span className="booking-option-sub">{subtitle}</span> : null}
                </div>
              </div>
            );
          })
        )}
      </div>
    </section>
  );
};

VenueSpacesSection.propTypes = {
  spaces: PropTypes.arrayOf(PropTypes.object)
};

VenueSpacesSection.defaultProps = {
  spaces: []
};

export default VenueSpacesSection;
